<mat-expansion-panel class="tool-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon *ngIf="!isLoading">build</mat-icon>
      <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
      <span class="tool-name">{{toolName}}</span>
    </mat-panel-title>
    <mat-panel-description *ngIf="explanation">
      {{explanation}}
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div class="tool-content">
    <div class="tool-section" *ngIf="toolInput">
      <div class="section-header">
        <h4>Input:</h4>
        <button mat-icon-button matTooltip="Copy to clipboard" (click)="copyToClipboard(rawInput)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <div class="code-block" [innerHTML]="parsedInput"></div>
    </div>
    
    <div class="tool-section" *ngIf="isLoading || toolOutput">
      <div class="section-header">
        <h4>Output:</h4>
        <button mat-icon-button matTooltip="Copy to clipboard" *ngIf="!isLoading" (click)="copyToClipboard(rawOutput)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="24"></mat-spinner>
        <span class="loading-text">Processing...</span>
      </div>
      <div *ngIf="!isLoading && toolOutput" class="output-content" [innerHTML]="parsedOutput"></div>
    </div>
  </div>
</mat-expansion-panel> 